import React from 'react';
import styled, { css } from 'styled-components';
import { rgba } from 'polished';

import { colors, neumorphism } from './constant';
import { respondTo } from './responsive';

const ToggleableButton = ({ value, setValue, children, className }) => {
    return (
        <Button className={className} value={value} type="button" onClick={e => setValue?.(!value)} >{ children }</Button>
    )
}

const Button = styled.button`
    border: 1px solid ${ colors.stroke };
    border-radius: 100em;
    padding: 8px 24px;
    display: inline;
    outline: none;
    background-color: transparent;

    color: ${ colors.text };
    font-size: 16px;

    transition: background-color .2s, box-shadow .1s, border .2s;

    &:hover {
        background-color: ${ rgba(colors.stroke, 0.05) };
    }

    ${({value}) => value && css`
        ${ neumorphism.concave };
        border: 1px solid ${ colors.body };
        background-color: ${ colors.bgButtonPressed };
    `}

    ${ respondTo.md } {
        font-size: 12px;
        padding: 4px 16px;
    }
`

export default ToggleableButton
